import { render, staticRenderFns } from "./LogHistory.vue?vue&type=template&id=1a405d7a&scoped=true"
import script from "./LogHistory.vue?vue&type=script&lang=js"
export * from "./LogHistory.vue?vue&type=script&lang=js"
import style0 from "./LogHistory.vue?vue&type=style&index=0&id=1a405d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a405d7a",
  null
  
)

export default component.exports